<template>
  <v-container fluid style="background-color: white">
    <v-row v-if="result" justify="space-between">
      <v-col cols="4">
        <h2>
          Olá<span v-if="pacienteName">, {{ pacienteName }}</span>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="logout">
                <v-icon>mdi-logout-variant</v-icon>
              </v-btn>
            </template>
            Sair
          </v-tooltip>
        </h2>
        <h3 v-if="result && result.requisicoesCount && result.examesCount">
          Você tem {{ result.examesCount }} exames de {{ result.requisicoesCount }} requisições
        </h3>
      </v-col>
      <v-col v-if="result && result.urlMotion" cols="4">
        <v-btn large @click="openInNewTab(result.urlMotion)" elevation="0" class="rounded-lg" color="primary">
          Exames anteriores a 16/05/2022
          <v-icon right>
            mdi-open-in-new
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="3">
        <v-text-field
          label="Pesquisar"
          hide-details="auto"
          prepend-inner-icon="mdi-magnify"
          outlined
          v-model="search"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-divider class="mt-2 mb-4"></v-divider>
    <template v-if="!examesLoading">
      <template v-if="result">
        <h3 class="mb-2">
          Exames da requisição {{ result.main.id }}
        </h3>
        <v-row>
          <v-col cols="12">
            <TableExames :exames="result.main.exames"></TableExames>
          </v-col>
        </v-row>
        <v-divider class="mt-8 mb-4"></v-divider>
        <h4 v-if="requisicoes.length" class="mb-2">Histórico de requisições:</h4>
        <v-expansion-panels accordion>
          <v-expansion-panel
            v-for="requisicao in filteredRequisicoes"
            :key="requisicao.id"
          >
            <v-expansion-panel-header>
              <v-row>
                <v-col cols="1">
                  <v-chip label class="mr-2" :color="requisicao.status === 'Liberado' ? 'green lighten-2' : 'blue-grey lighten-4'">
                    Nº: {{requisicao.id}}
                  </v-chip>
                </v-col>
                <v-col>
                  <v-chip  label class="">
                    <v-icon left>
                      mdi-calendar
                    </v-icon>
                    {{requisicao.date}}
                  </v-chip>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col cols="12">
                  <TableExames :exames="requisicao.exames"></TableExames>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </template>
      <template v-else>
        <v-row>
          <v-col cols="12">
            <h3>Nenhum resultado encontrado</h3>
          </v-col>
        </v-row>
      </template>
    </template>
    <template v-if="examesLoading">
      <div class="d-flex justify-center">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
    </template>

  </v-container>
</template>

<script>
import { api } from '@/api'
import TableExames from '@/components/TableExames'

export default {

  components: {
    TableExames
  },

  data () {
    return {
      search: '',
      exames: [],

      result: null,
      examesLoading: false
    }
  },

  mounted () {
    this.getExames()
  },

  methods: {
    async getExames () {
      this.examesLoading = true
      this.$set(this, 'exames', [])
      try {
        const response = await api.post('/exame/paciente', {
          protocolo: this.$store.state.credentials.numeroExame,
          senha: this.$store.state.credentials.password
        })
        console.log(response.data)
        this.$set(this, 'result', response?.data || null)
      } catch (error) {
        console.log(error)
      } finally {
        this.examesLoading = false
      }
    },
    logout () {
      this.$store.commit('clearCredentials')
      this.$router.push('/')
    },
    openInNewTab (url) {
      window.open(url, '_blank').focus()
    }
  },

  computed: {
    requisicoes () {
      return this.result?.entries || []
    },
    filteredRequisicoes () {
      if (!this.search) return this.requisicoes
      return this.requisicoes.filter(requisicao => {
        return JSON.stringify(requisicao).toLowerCase().includes(this.search.toLowerCase())
      })
    },
    pacienteName () {
      return this.result?.pacienteName || ''
    }
  }

}
</script>

<style>

</style>
